interface AddProps {
    color?: string;
    width?: number;
    height?: number;
}

const Add = ({
    color = 'black',
    width = 16,
    height = 16
}: AddProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M12 5V19M5 12H19"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Add;

